export const AUTH_GLOBAL_ERROR_CODES = {
  NONE: null,
  INVALID_TOKEN: 'INVALID_TOKEN',
  MIGRATION_IN_PROGRESS: 'MIGRATION_IN_PROGRESS',
  ALREADY_LOGGED_IN: 'ALREADY_LOGGED_IN',
};